module.exports = __webpack_public_path__ + "static/media/cert51.0ab425f2.jpeg";